<div class="c-message-header__container c-message-header__container--error">
    <div class="c-message-header__desc">
        <span>{{ message }}</span>
    </div>
    <button (click)="close()" class="c-message-header__close"></button>
</div>
